import { makeAutoObservable } from 'mobx';

class SignalsStore {
  signals = [];

  tickers = [];

  assetsList = [];

  forexEvents = [];

  forexIDs = [];

  assetsNews = [];

  selectedSignal = null;

  constructor() {
    makeAutoObservable(this);
  }

  setSelectedSignal = (signal) => {
    this.selectedSignal = signal;
  };

  setAssetsList = (assets) => {
    this.assetsList = assets;
  };

  setForexEvents = (events) => {
    this.forexEvents = events;
  };

  setforexIDs = (ids) => {
    this.forexIDs = ids;
  };

  setAssetsNews = (assets) => {
    this.assetsNews = assets;
  };

  setTickers = (newTickers) => {
    this.tickers = newTickers;
  };
}

export default new SignalsStore();
